import {StrictMode, useState, useMemo} from 'react'
import {createRoot} from 'react-dom/client'
import {ThemeProvider} from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'

import App from './App'
import ApplicationError from './components/ApplicationError'
import ErrorBoundary from './components/ErrorBoundary'
import {StateContext, DispatchContext, UserContext} from './state/contexts'

import auth from './state/reducers/auth'
import clients from './state/reducers/clients'
import consents from './state/reducers/consents'
import {useReducers} from './state/hooks/reducers'
import emails from './state/reducers/emails'
import faktory from './state/reducers/faktory'
import invites from './state/reducers/invites'
import metadata from './state/reducers/metadata'
import oauth from './state/reducers/oauth'
import passwords from './state/reducers/passwords'
import pendingWraps from './state/reducers/pendingWraps'
import recovery from './state/reducers/recovery'
import recoveryContacts from './state/reducers/recoveryContacts'
import recoveryRequest from './state/reducers/recoveryRequest'
import releasedKeyShares from './state/reducers/releasedKeyShares'
import roles from './state/reducers/roles'
import tfa from './state/reducers/tfa'
import tfaEnrollment from './state/reducers/tfaEnrollment'
import theme from './theme'
import userKey from './state/reducers/userKey'
import users from './state/reducers/users'
import routes from './routes'

import '@fontsource/funnel-display/300.css'
import '@fontsource/funnel-display/400.css'
import '@fontsource/funnel-display/500.css'
import '@fontsource/funnel-display/600.css'
import '@fontsource/funnel-display/700.css'
import '@fontsource/funnel-display/800.css'
import './assets/styles/global.scss'

const Root = () => {
  const [mode, setMode] = useState('user')
  const state = useReducers({
    auth,
    clients,
    consents,
    emails,
    faktory,
    invites,
    metadata,
    oauth,
    passwords,
    pendingWraps,
    recovery,
    recoveryContacts,
    recoveryRequest,
    releasedKeyShares,
    roles,
    tfa,
    tfaEnrollment,
    userKey,
    users
  })
  const contextValue = useMemo(() => ({mode, setMode}), [mode])

  return (
    <StrictMode>
      <StateContext value={state.reducers}>
        <DispatchContext value={state.dispatchs}>
          <UserContext value={contextValue}>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <ErrorBoundary fallback={<ApplicationError />}>
                <App routes={routes} />
              </ErrorBoundary>
            </ThemeProvider>
          </UserContext>
        </DispatchContext>
      </StateContext>
    </StrictMode>
  )
}

createRoot(document.getElementById('root')).render(<Root />)
